// extracted by mini-css-extract-plugin
export default {"container":"rakutenAward_container__sAt4X"};